import { render } from "./SwitchOwner.vue?vue&type=template&id=39e47a62"
import script from "./SwitchOwner.vue?vue&type=script&lang=js"
export * from "./SwitchOwner.vue?vue&type=script&lang=js"

import "./SwitchOwner.vue?vue&type=style&index=0&id=39e47a62&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_cb461e37a40e4d4db048201803700c7a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__